import { useEffect, useCallback } from 'react';
import { useRoutes } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import { setActivePermissions } from './store/dictionaries/slice';
import {
  useLazyGetDashboardPermissionsQuery,
  useLazyGetDashboardWhitelabelQuery,
} from './store/dictionaries/services';
import Dashboard from './hoc/dashboard/dashboard';

import ROUTES from './routes';

export const routes = {
  path: ROUTES.DASHBOARD,
  element: <Dashboard />,
};

const DashboardRoutes = () => {
  const elements = useRoutes([{ ...routes }]);

  const dispatch = useAppDispatch();

  const { activePermissions, whitelabel } = useAppSelector(
    (state) => state.dashboardDictionaries,
  );

  const [getDashboardPermissions] = useLazyGetDashboardPermissionsQuery();
  const [getDashboardWhiteLabel] = useLazyGetDashboardWhitelabelQuery();

  const getDashboardPermissionsAction = useCallback(() => {
    getDashboardPermissions();
  }, []);

  const permissions = JSON.parse(
    localStorage.getItem('activePermissions') as string,
  );

  useEffect(() => {
    const companyName = localStorage.getItem('companyName');

    if (!companyName) {
      getDashboardWhiteLabel();
    }
  }, []);

  useEffect(() => {
    if (whitelabel) {
      localStorage.setItem('companyName', whitelabel?.data?.value?.companyName);
    }
  }, [whitelabel]);

  useEffect(() => {
    if (permissions && !activePermissions) {
      dispatch(setActivePermissions(permissions));
    } else if (!permissions && !activePermissions) {
      getDashboardPermissionsAction();
    }
  }, [permissions, getDashboardPermissionsAction, dispatch, activePermissions]);

  return elements;
};

export default DashboardRoutes;
